import * as Yup from 'yup'

import { isValueNumberType } from '../../../../../utils/common'
import { toApplicantHouseholdSizeSelectItems } from '../../../../RentalPortalApplicant'
import {
  getListingDateValue,
  parseListingDayInAppTimezone,
} from '../../../RentalPortal.utils'
import { getApplicantShortDate } from '../../RentalPortalApplicantProfileHeaderInfoItems'

import {
  APPLICANT_MATCHING_FIELD_NAME_HOUSEHOLD_SIZE,
  APPLICANT_MATCHING_FIELD_NAME_MOVE_IN_DATE,
  APPLICANT_MATCHING_ROW,
} from './ApplicantMatchingWidget.constants'

function getHasApplicantHouseholdSize(applicantData) {
  return isValueNumberType(applicantData?.household_size)
}

export function getApplicantMatchingRows({
  applicantData,
  locale,
  t,
  timezone,
}) {
  const householdSize = applicantData?.household_size

  return [
    {
      key: APPLICANT_MATCHING_ROW.moveInDate,
      label: t('RentalPortal.ApplicantProfileMatchingMoveInLabelKey'),
      value:
        getApplicantShortDate({
          date: parseListingDayInAppTimezone(
            applicantData?.move_in_date,
            timezone
          ),
          locale,
          timezone,
        }) || t('Select.NoDataKey'),
    },
    {
      key: APPLICANT_MATCHING_ROW.householdSize,
      label: t('RentalPortal.ApplicantProfileMatchingHouseholdLabelKey'),
      value: !getHasApplicantHouseholdSize(applicantData)
        ? t('Select.NoDataKey')
        : t('RentalPortal.ApplicantFormHouseholdSizeOptionKey', {
            count: householdSize,
          }),
    },
  ]
}

export function getApplicantMatchingInitialValues({
  applicantData,
  t,
  timezone,
}) {
  const householdSize = applicantData?.household_size

  return {
    [APPLICANT_MATCHING_FIELD_NAME_HOUSEHOLD_SIZE]:
      !getHasApplicantHouseholdSize(applicantData)
        ? null
        : toApplicantHouseholdSizeSelectItems({ sizes: [householdSize], t })[0],
    [APPLICANT_MATCHING_FIELD_NAME_MOVE_IN_DATE]: parseListingDayInAppTimezone(
      applicantData?.move_in_date,
      timezone
    ),
  }
}

export function getApplicantMatchingValidationSchema() {
  return Yup.object({
    [APPLICANT_MATCHING_FIELD_NAME_HOUSEHOLD_SIZE]: Yup.object()
      .nullable()
      .required(true),
    [APPLICANT_MATCHING_FIELD_NAME_MOVE_IN_DATE]: Yup.date().nullable(),
  })
}

export function getApplicantMatchingPatchPayload(values) {
  return {
    household_size:
      values[APPLICANT_MATCHING_FIELD_NAME_HOUSEHOLD_SIZE]?.value ?? null,
    move_in_date: getListingDateValue(
      values[APPLICANT_MATCHING_FIELD_NAME_MOVE_IN_DATE]
    ),
  }
}
